import Box from '@mui/material/Box';
import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import PriceFilter from 'components/FilterFields/PriceFilter';
import AdvancedDateFilter from 'components/FilterFields/AdvancedDateFilter';

function PropertyValuesFilterNz(props) {
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Property Values</Typography>
            <Grid container spacing={3}>
                <Grid item size={6}>
                    <PriceFilter
                        label="Capital Value"
                        subLabel="Select an option or manually enter a value"
                        attrName="valuationCapitalValue"
                        comparableType={props.comparableType}
                        isDropdown={false}
                    />
                </Grid>
                <Grid item size={1} />
                <Grid item size={5}>
                    <AdvancedDateFilter
                        header="Valuation Date"
                        comparableType={props.comparableType}
                        label="Select Range"
                        attr="valuationAssessmentDate"
                        displayRight
                    />
                </Grid>
            </Grid>

            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
            <Grid container spacing={3}>
                <Grid item size={6}>
                    <PriceFilter
                        label="Land Value"
                        subLabel="Select an option or manually enter a value"
                        attrName="valuationLandValue"
                        comparableType={props.comparableType}
                        isDropdown={false}
                    />
                </Grid>
                <Grid item size={6}>
                    <PriceFilter
                        label="Improvements Value"
                        subLabel="Select an option or manually enter a value"
                        attrName="valuationImprovementsValue"
                        comparableType={props.comparableType}
                        isDropdown={false}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default PropertyValuesFilterNz;